import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@paygreen/paygreen-ui';
import { PartnershipCardGrid } from './PartnershipCard.styled';

const PartnershipCardSkeleton = ({
    lineNumber,
    blockWidth,
    repeat,
    ...rest
}) => (
    <PartnershipCardGrid>
        {[...Array(repeat)].map((el, index) => (
            <Skeleton
                key={index}
                blockWidth={blockWidth}
                backgroundColor="grey10"
                colorWab="grey20"
                lineNumber={lineNumber}
                shadowSize="none"
                hasResponsivePadding={true}
                padding="md"
                radiusSize="sm"
                {...rest}
            />
        ))}
    </PartnershipCardGrid>
);

PartnershipCardSkeleton.propTypes = {
    lineNumber: PropTypes.number,
    blockWidth: PropTypes.string,
    repeat: PropTypes.number,
};

PartnershipCardSkeleton.defaultProps = {
    blockWidth: 'none',
    lineNumber: 1,
    repeat: 2,
};

export default PartnershipCardSkeleton;
